import { render, staticRenderFns } from "./RolesManage.vue?vue&type=template&id=7b7ae6e9&scoped=true"
import script from "./RolesManage.vue?vue&type=script&lang=js"
export * from "./RolesManage.vue?vue&type=script&lang=js"
import style0 from "./RolesManage.vue?vue&type=style&index=0&id=7b7ae6e9&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"
import style1 from "./RolesManage.vue?vue&type=style&index=1&id=7b7ae6e9&prod&module=true&lang=stylus&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7b7ae6e9",
  null
  
)

export default component.exports